import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_ITEM,
    FETCH_ITEM_FAILURE,
    FETCH_ITEM_SUCCESS,
    FETCH_PRESETS,
    FETCH_PRESETS_FAILURE,
    FETCH_PRESETS_SUCCESS,
    FETCH_SYSTEMS_CATALOG,
    FETCH_SYSTEMS_CATALOG_FAILURE,
    FETCH_SYSTEMS_CATALOG_SUCCESS,
    INITIALIZE_FORM,
    OPEN_MODAL,
    RESET_FORM,
    SAVE_ITEM,
    SAVE_ITEM_FAILURE,
    SAVE_ITEM_SUCCESS,
    SAVE_PREFERENCE,
    SAVE_PREFERENCE_FAILURE,
    SAVE_PREFERENCE_SUCCESS,
    SET_IS_NEW_RECORD,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    fetchItem: { data: {}, errors: null, isFetching: false },
    fetchPresets: {
        data: [],
        errors: null,
        isFetching: false,
    },
    fetchSystems: { data: [], errors: null, isFetching: false },
    initialValues: {
        id: null,
        system_id: null,
        system_uniqueid: '',
    },
    isNewRecord: true,
    isOpenModal: false,
    saveItem: { errors: null, isSaving: false },
    savePreference: { errors: null, isSaving: false },
};

const slice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_SYSTEMS_CATALOG]: (state) => {
            state.fetchSystems = {
                ...state.fetchSystems,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_SYSTEMS_CATALOG_FAILURE]: (state, action) => {
            state.fetchSystems = {
                ...state.fetchSystems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_SYSTEMS_CATALOG_SUCCESS]: (state, action) => {
            state.fetchSystems = {
                ...state.fetchSystems,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRESETS]: (state) => {
            state.fetchPresets = {
                ...state.fetchPresets,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PRESETS_FAILURE]: (state, action) => {
            state.fetchPresets = {
                ...state.fetchPresets,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRESETS_SUCCESS]: (state, action) => {
            state.fetchPresets = {
                ...state.fetchPresets,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM]: (state) => {
            state.fetchItem = {
                ...state.fetchItem,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEM_FAILURE]: (state, action) => {
            state.fetchItem = {
                ...state.fetchItem,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEM_SUCCESS]: (state, action) => {
            state.fetchItem = {
                ...state.fetchItem,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
            state.saveItem = INITIAL_STATE.saveItem;
        },
        [SAVE_ITEM]: (state) => {
            state.saveItem = { ...state.saveItem, errors: [], isSaving: true };
        },
        [SAVE_ITEM_FAILURE]: (state, action) => {
            state.saveItem = {
                ...state.saveItem,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_ITEM_SUCCESS]: (state) => {
            state.saveItem = {
                ...state.saveItem,
                isSaving: false,
            };
        },
        [SAVE_PREFERENCE]: (state) => {
            state.savePreference = {
                ...state.savePreference,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PREFERENCE_FAILURE]: (state, action) => {
            state.savePreference = {
                ...state.savePreference,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PREFERENCE_SUCCESS]: (state) => {
            state.savePreference = {
                ...state.savePreference,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;
